import type { MailboxCollectorMappingAddon } from 'owa-analytics-types';
import type { AccountKey } from 'owa-client-types';
import { getAnalyticsAddon } from 'owa-analytics-addons';
import { isEMEARegion } from 'owa-config/lib/isEMEARegion';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Deprecating getPhysicalRing.ts
 *	> 'getVariantEnvironment' import from 'owa-metatags' is restricted. This value is resolved in ECS as a filter. Please create a feature flight if possible. */
import { getVariantEnvironment, getOneDsUrl, OneDsCollectorUrlSuffix } from 'owa-metatags';
import { trace } from 'owa-trace';

const EUDB_COLLECTOR_ENDPOINT = 'https://eu-office.events.data.microsoft.com/';
const GCC_HIGH_COLLECTOR_ENDPOINT = 'https://tb.events.data.microsoft.com/';
const DOD_COLLECTOR_ENDPOINT = 'https://pf.events.data.microsoft.com/';

export function getCollectorUrl(
    forest: string | undefined,
    dontLogInEU?: boolean
): string | undefined {
    // Try to use "x-owa-forest" response header to decide if user is in EUDB data residency
    if (isEMEARegion(forest) && !dontLogInEU) {
        return EUDB_COLLECTOR_ENDPOINT + OneDsCollectorUrlSuffix;
    }

    // Try to get collector endpoint from "ApplicationConfig.AriaUrl" ECS setting
    const url = getOneDsUrl();
    if (url) {
        return url;
    }

    // Fall-back to hardcoded values for special environments
    const environment = getVariantEnvironment();
    if (environment === 'GccHigh') {
        return GCC_HIGH_COLLECTOR_ENDPOINT + OneDsCollectorUrlSuffix;
    } else if (environment === 'DoD') {
        return DOD_COLLECTOR_ENDPOINT + OneDsCollectorUrlSuffix;
    }

    // Use default collector endpoint that is provided by 1DS SDK
    return undefined;
}

const accountKeys = new Set<AccountKey>();

export function getCollectorUrlForMailbox(accountKey: AccountKey | undefined): string | undefined {
    // Eventually we will want to make the accountKey mandatory, but it's not for now
    if (!accountKey) {
        return undefined;
    }

    const addon =
        getAnalyticsAddon<MailboxCollectorMappingAddon>('MailboxCollectorMapping')?.executeNow();
    const mailboxCollectorUrl = addon?.getCollectorUrlForMailbox(accountKey);

    // Log if we have an accountKey but no mapping found
    if (!mailboxCollectorUrl) {
        trace.warn(
            `[CollectorUrl] No collector URL mapping found for accountKey: ${accountKey}`,
            'analytics'
        );
    } else {
        if (!accountKeys.has(accountKey)) {
            trace.info(
                `[CollectorUrl] Using collector URL: ${mailboxCollectorUrl} for accountKey: ${accountKey}`,
                'analytics'
            );
            accountKeys.add(accountKey);
        }

        return mailboxCollectorUrl + OneDsCollectorUrlSuffix;
    }

    return undefined;
}
